module.exports = __webpack_public_path__ + "img/caution1.8960ff13.png";